<script setup lang="ts">
import AppHead                  from "@ViewCommonComponents/AppHead.vue";
import { onMounted, onUpdated } from "vue";
import { useModalStore }        from "@TsStore/modalStore";
import MessageModalWindow       from "@ViewCommonComponents/MessageModalWindow.vue";

type TypeProps = {
    title?: string,
    description?: string,
    meta_title?: string,
    meta_description?: string,
    robots?: string,
    success?: string,
    error?: string,
    headerClass?: string,
};

const props = defineProps<TypeProps>(),
    storeModal = useModalStore();

const processAlertMessages = (): void => {
    storeModal.setIsOpenModal(!!(props.success ?? props.error ?? '').length);

    if (props.success) {
        storeModal.setSuccessMessage(props.success);
    } else if (props.error) {
        storeModal.setErrorMessage(props.error);
    }
};

onMounted(() => {
    processAlertMessages();
});

onUpdated(() => {
    processAlertMessages();
});
</script>

<template>
    <AppHead v-bind="$props"/>

    <div class="wrapper flex flex-col min-h-full">
        <header :class="['header', headerClass]" id="header">
            <slot name="header"></slot>
        </header>

        <main class="main flex-auto">
            <slot name="main"></slot>
        </main>

        <footer class="footer">
            <slot name="footer"></slot>
        </footer>
    </div>

    <MessageModalWindow></MessageModalWindow>
</template>
